module.exports = {"id":"189177","name":"John Fleck","rating":"72","photo":"./data/images/photos/1/189177.png","club":{"name":"Sheffield Utd","logo":"./data/images/clubs/SheffieldUtd.png"},"positions":["MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JohnFleck0.json
// module id = 2074
// module chunks = 0